<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="ViewRecord" />
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="GlobeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="lesPlusProches" />
    </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    lesPlusProches()
    {
        this.$router.push("/person-distance/" + this.params.data.id).catch(() => {})
    },
    editRecord () {
        this.$router.push("/person-edit/" + this.params.data.id).catch(() => {})
    },
    ViewRecord () {
        this.$router.push("/person/" + this.params.data.id).catch(() => {})
    }
  }
}
</script>
